module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAJ9JREFUSEvtlbEOwiAQhr9Otot24AF8REfduunoI/YBGFoX20lzCUNLaOg1IaYRFhK44w/f/QeFhQ8JR5EFYnQ1iEbg6Q68AIfY4bKvEegN1JJkoQNOWcAnsB9EA/AOFPBl4OyK3ALHQEwFlNP1kIseBm5rHOLHWLgD158LJEe0RGc/Lso3mBHQvKbirsZlyzxrqCWuGoEtvaf6D/5U4AtLq2AhZ/rRGAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/order/show-icon.png
// module id = 5D8x
// module chunks = 1